import React from 'react';
import { Box, Flex, FormLabel, FormControl,FormHelperText } from '@chakra-ui/react';
import { useColorModeValue } from '@chakra-ui/color-mode';


export default function Formfield({children, ...props }) {
    const required = props.required ? true : false;
    let muteColor = useColorModeValue("gray.400", "white");
    let display = props.display ? props.display : 'flex';
    let displaymargin = display==="block" ? "10px" : "0";

    // Boxed mode (opt-in via the `boxed` prop): a single bordered box holds
    // both the label (small, top) and the field, instead of a separate
    // label column — used by the grid-mode property form.
    const boxedLabelColor = useColorModeValue("gray.600", "whiteAlpha.800");
    if (props.boxed) {
        return (
            <FormControl
                id={props.label ? props.label.toLowerCase().replace(/ /g, "_") : null}
                isRequired={required}
                gridColumn={props.gridColumn}
                mb={props.mb !== undefined ? props.mb : "16px"}
            >
                <Box
                    borderWidth="1px"
                    borderColor="gray.200"
                    borderRadius="12px"
                    bg="white"
                    px="16px"
                    py="8px"
                    cursor="text"
                    transition="border-color 0.15s, box-shadow 0.15s"
                    _focusWithin={{ borderColor: "brand.500", boxShadow: "0 0 0 3px rgba(66,44,250,0.12)" }}
                >
                    {props.label &&
                        <FormLabel fontSize="11px" fontWeight="600" color={boxedLabelColor} mb="1px" textTransform="uppercase" letterSpacing="0.02em">
                            {props.label}
                        </FormLabel>
                    }
                    {children}
                    {props.help ? <FormHelperText color={muteColor} fontSize='xs'>{props.help}</FormHelperText> : null}
                </Box>
            </FormControl>
        );
    }

    return (
        <FormControl id={props.label ? props.label.toLowerCase().replace(/ /g, "_") : null} isRequired={required} mb="20px" gridColumn={props.gridColumn}>
            <Flex display={{ base: "block", md: display }}>

                {props.label &&
                <Box flex="4" display='flex' alignItems='center' mb={{ 'sm': "10px", 'md': displaymargin }}>
                    <FormLabel mb={0}>{props.label}</FormLabel>
                </Box> }

                <Box flex="12">
                    {children}
                    {props.help ? <FormHelperText color={muteColor} fontSize='xs'>{props.help}</FormHelperText> : null}
                </Box>
            </Flex>
        </FormControl>
    );
}

